const updates = [
  { time: '刚刚', text: '《剑与远方》第87话更新——"龙脊山脉的试炼"篇章正式开启', tag: '连载更新', accent: true },
  { time: '15分钟前', text: '《修灵纪》第124话已上线，本话超长篇幅诚意满满，不容错过', tag: '连载更新', accent: false },
  { time: '1小时前', text: '新作《妖灵异谈》正式上架酷漫屋，日漫奇幻题材独家首发', tag: '新作上架', accent: true },
  { time: '2小时前', text: '《心跳的频率》第52话甜度爆表，男女主终于表白！读者直呼过瘾', tag: '连载更新', accent: false },
  { time: '3小时前', text: '热门话题"国漫崛起"专栏更新，新增三部优质国漫作品推荐', tag: '专题更新', accent: false },
  { time: '5小时前', text: '《星界战记》第91话战斗场面高燃，星际舰队大战外星文明', tag: '连载更新', accent: true },
  { time: '7小时前', text: '酷漫屋移动端版本更新至v3.2.0，优化竖屏滑动阅读流畅度', tag: '系统公告', accent: false },
  { time: '10小时前', text: '读者最爱榜单刷新，《暗影追踪》排名跃升至第6位，热度持续攀升', tag: '榜单变动', accent: false },
  { time: '12小时前', text: '冬日阅读季专题活动预告，多部热门漫画即将开启限时加更', tag: '活动预告', accent: true },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            酷漫屋实时动态快讯，第一时间了解平台内容更新和最新消息
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((u, i) => (
            <div
              key={i}
              className="flex items-start gap-4 pb-4 mb-4 border-b border-background-200/70 last:border-b-0 last:pb-0 last:mb-0"
            >
              <div className="flex-shrink-0 flex flex-col items-center">
                {u.accent ? (
                  <div className="w-2.5 h-2.5 rounded-full bg-accent-500 mt-1.5"></div>
                ) : (
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-300 mt-1.5"></div>
                )}
                {i < updates.length - 1 && <div className="w-px h-full bg-background-200/70 mt-1"></div>}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-0.5">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{u.time}</span>
                  <span className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap ${
                    u.accent
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {u.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{u.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}